import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconItalic$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconItalic extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'a7e27f78d912596758d011b66c23c8e29faaef3a', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'cebc46fb1c73dbac13f57a5bf61c86493ad7c0ea', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '3b0002e23950bd2ffbe605903ae3858673a9e222', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M8 4.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H13l-1 10h1.5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-6a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5H9l1-10H8.5a.5.5 0 0 1-.5-.5z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-italic", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-italic"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-italic":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconItalic$1);
            }
            break;
    } });
}

const CosmosIconItalic = CosmosIconItalic$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconItalic, defineCustomElement };
